export default __webpack_public_path__ + "static/media/06.ea93a8bd.jpg";